/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Descrição',
    END_DATE: 'Até',
    ID: 'Id',
    OBJECTIVE: 'Objectivo',
    REWARD: 'Prémio',
    START_DATE: 'Desde'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Valor acumulado',
    ACTIVES: 'Activos',
    AT: 'Em',
    COUPON: 'Cupão',
    CREATED: 'Criado',
    DAY_VALUE: 'Valor dia',
    FAIL: 'Falha',
    FINISHED: 'Terminado',
    HISTORY: 'Histórico',
    IN_PROGRESS: 'Em Curso',
    MONETARY_REWARD: 'Prémio valor',
    NR_ACCESSES: 'Nº acessos',
    NR_NEW_CLIENTS: 'Novos clientes',
    NR_ORDERS: 'Nº Encomendas',
    OBJECTIVE: 'Objectivo',
    OBJECTIVE_VALUE: 'Valor objectivo',
    OFFER: 'Oferta',
    OPEN: 'Aberto',
    REMUNERATION: 'Remuneração',
    REWARD_TYPE: 'Tipo de recompensa',
    REWARD_TYPES: 'Tipos de prémios',
    SALES: 'Vendas',
    SALES_BRANDS: 'Vendas linhas de marca (€)',
    SALES_BRANDS_QTY: 'Vendas linhas de marca (Qtd)',
    SALES_CATEGORY: 'Vendas categoria (€)',
    SALES_CATEGORY_QTY: 'Vendas categoria (Qtd)',
    SALES_COMMISSIONS: 'Comissões sobre as vendas',
    SALES_PRODUCTS: 'Vendas de produtos (€)',
    SALES_PRODUCTS_QTY: 'Vendas de produtos (Qtd)',
    SUCCESS: 'Sucesso',
    TO: '{0} até {1}',
    TODAY: 'Hoje'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Sem desafios ativos (ainda)',
    CHALLANGES_TITLE: 'Sem desafios.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
